/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-19 11:14:51
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { toVisualThousands } from "../utils";
import { labelFont } from "../visualConfig";

export default ({ title, list = [], color = [] }) => {
  // 创建一个数据项到排名的映射
  let rankedData = list.map(function(item, index) {
    return {data: item, rank: index + 1};
  }).sort(function(a, b) {
    return b.data.value - a.data.value; // 根据 value 降序排序
  });

  // 将排序后的排名信息映射回原始数据（通过 name 属性）
  let rankMap = {};
  rankedData.forEach(function(item, rankIndex) {
    rankMap[item.data.name] = rankIndex + 1; // 注意这里 rankIndex 是从 0 开始的，所以要加 1
  });

  return {
    title: {
      text: title,
    },
    color,
    legend: {
      show: false,
    },
    tooltip: {},
    graphic: [
      {
        type: 'group',
        // left: '10%',
        right: 10,
        bottom: 10,
        children: [
          {
            type: 'rect',
            z: 100,
            left: 'center',
            top: 'middle',
            shape: {
              width: 270,
              height: 70
            },
            style: {
              fill: '#fff',
              stroke: '#555',
              lineWidth: 0,
              shadowBlur: 8,
              shadowOffsetX: 3,
              shadowOffsetY: 3,
              shadowColor: 'rgba(0,0,0,0)'
            }
          },
          {
            type: 'text',
            z: 100,
            left: 'center',
            top: 'middle',
            style: {
              fill: '#000',
              width: 260,
              lineHeight: 20,
              fontSize: 12,
              fontWeight: 'bold',
              overflow: 'break',
              text: '*注：“TOP10内容引爆力”指所有与某品牌相关的内容中（包括主动传播和被报道、被提及内容），传播力最高的10条内容的数值之和。',
              font: '14px Microsoft YaHei'
            }
          }
        ]
      }
    ],
    // 加排名代码
    series: [
      {
        type: 'treemap',
        top: 10,
        left: 200,
        right: 300,
        bottom: 10,
        label: {
          formatter: function(params) {
            // 使用 rankMap 来获取当前数据项的排名
            var rank = rankMap[params.name];
            return `{name|${params.name}}\n{value|${toVisualThousands(params.value)}} {unit|DB}\n{value|No.${rank}}`
          },
          ...labelFont,
          position: ['50%', '30%'],
          align: 'center',
          fontSize: 18,
          lineHeight: 18,
          rich: {
            name: {
              fontSize: 18,
            },
            value: {
              fontSize: 12,
              lineHeight: 16,
            },
            unit: {
              fontStyle: 'italic',
            }
          }
        },
        breadcrumb: {
          show: false,
        },
        data: list.map((item, index) => ({
          ...item,
          itemStyle: {
            borderWidth: 1,
            gapWidth: 2,
            color: color[index]
          }
        })),
        roam: false,
        nodeClick: false,
        silent: true,
      }
    ]
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P3/chart.js